import {getSubjectList} from "../api/subject";

export const subjectPromiseOptions = async () => {
    const result = await getSubjectList();

    const output = [];
    if (result?.data && Array.isArray(result.data)) {
        result?.data.forEach(ele => {
            output.push({value: ele.id, label: ele.title, subject: ele})
        })
    }
    return output
}
